import Vue from 'vue';
import ReservationStep from '@/types/reservationStep';
import { getOrZero } from '@/utilities/helpers';

export default Vue.extend({
	computed: {
		step(): ReservationStep {
			return getOrZero('reservation.step', this.$store.state) as ReservationStep;
		},
	},

	data() {
		return {
			Step: ReservationStep,
		};
	},

	methods: {
		setStep(step: ReservationStep) {
			return this.$store.commit('reservation/setStep', step);
		},
	},
});
